<template>
  <div class="product-images">
    <template v-if="useCarousel">
      <div ref="previews" class="previews">
        <carousel
          :per-page="1"
          :start-at="activeItem"
          :carousel-identifier="carouselidentifier"
          :vertical="false"
          :pagination-enabled="false"
          :navigation-enabled="true"
        >
          <slide v-if="pdpsrc1.mobile" class="preview">
            <span :class="['product-badge', badgetext ? '' : 'hide-badge']">{{ badgetext }}</span>
            <picture>
              <source :srcset="pdpsrc1.desktop" media="(min-width: 1024px)" />
              <source :srcset="pdpsrc1.mobile" media="(min-width: 425px)" />
              <img :alt="pdpsrc1.alt" :src="pdpsrc1.mobile" />
            </picture>
          </slide>
          <slide v-if="pdpsrc2.mobile" class="preview">
            <span :class="['product-badge', badgetext ? '' : 'hide-badge']">{{ badgetext }}</span>
            <picture>
              <source :srcset="pdpsrc2.desktop" media="(min-width: 1024px)" />
              <source :srcset="pdpsrc2.mobile" media="(min-width: 425px)" />
              <img :alt="pdpsrc2.alt" :src="pdpsrc2.mobile" />
            </picture>
          </slide>
          <slide v-if="pdpsrc3.mobile" class="preview">
            <span :class="['product-badge', badgetext ? '' : 'hide-badge']">{{ badgetext }}</span>
            <picture>
              <source :srcset="pdpsrc3.desktop" media="(min-width: 1024px)" />
              <source :srcset="pdpsrc3.mobile" media="(min-width: 425px)" />
              <img :alt="pdpsrc3.alt" :src="pdpsrc3.mobile" />
            </picture>
          </slide>
          <slide v-if="pdpsrc4.mobile" class="preview">
            <span :class="['product-badge', badgetext ? '' : 'hide-badge']">{{ badgetext }}</span>
            <picture>
              <source :srcset="pdpsrc4.desktop" media="(min-width: 1024px)" />
              <source :srcset="pdpsrc4.mobile" media="(min-width: 425px)" />
              <img :alt="pdpsrc4.alt" :src="pdpsrc4.mobile" />
            </picture>
          </slide>
          <slide v-if="pdpsrc5.mobile" class="preview">
            <span :class="['product-badge', badgetext ? '' : 'hide-badge']">{{ badgetext }}</span>
            <picture>
              <source :srcset="pdpsrc5.desktop" media="(min-width: 1024px)" />
              <source :srcset="pdpsrc5.mobile" media="(min-width: 425px)" />
              <img :alt="pdpsrc5.alt" :src="pdpsrc5.mobile" />
            </picture>
          </slide>
          <slide v-if="pdpsrc6.mobile" class="preview">
            <span :class="['product-badge', badgetext ? '' : 'hide-badge']">{{ badgetext }}</span>
            <picture>
              <source :srcset="pdpsrc6.desktop" media="(min-width: 1024px)" />
              <source :srcset="pdpsrc6.mobile" media="(min-width: 425px)" />
              <img :alt="pdpsrc6.alt" :src="pdpsrc6.mobile" />
            </picture>
          </slide>
        </carousel>
      </div>
    </template>
    <template v-else>
      <div ref="previews" class="previews">
        <carousel
          :per-page="4"
          :start-at="activeItem"
          :carousel-identifier="carouselidentifier"
          :vertical="true"
          :pagination-enabled="false"
          :navigation-enabled="true"
        >
          <slide v-if="pdpsrc1.desktop" class="preview">
            <button style="border: none" @click="setActive(0)">
              <picture>
                <source :srcset="pdpsrc1.desktop" media="(min-width: 1024px)" />
                <source :srcset="pdpsrc1.mobile" media="(min-width: 425px)" />
                <img :alt="pdpsrc1.alt" :src="pdpsrc1.mobile" />
              </picture>
            </button>
          </slide>
          <slide v-if="pdpsrc2.desktop" class="preview">
            <button style="border: none" @click="setActive(1)">
              <picture>
                <source :srcset="pdpsrc2.desktop" media="(min-width: 1024px)" />
                <source :srcset="pdpsrc2.mobile" media="(min-width: 425px)" />
                <img :alt="pdpsrc2.alt" :src="pdpsrc2.mobile" />
              </picture>
            </button>
          </slide>
          <slide v-if="pdpsrc3.desktop" class="preview">
            <button style="border: none" @click="setActive(2)">
              <picture>
                <source :srcset="pdpsrc3.desktop" media="(min-width: 1024px)" />
                <source :srcset="pdpsrc3.mobile" media="(min-width: 425px)" />
                <img :alt="pdpsrc3.alt" :src="pdpsrc3.mobile" />
              </picture>
            </button>
          </slide>
          <slide v-if="pdpsrc4.desktop" class="preview">
            <button style="border: none" @click="setActive(3)">
              <picture>
                <source :srcset="pdpsrc4.desktop" media="(min-width: 1024px)" />
                <source :srcset="pdpsrc4.mobile" media="(min-width: 425px)" />
                <img :alt="pdpsrc4.alt" :src="pdpsrc4.mobile" />
              </picture>
            </button>
          </slide>
          <slide v-if="pdpsrc5.desktop" class="preview">
            <button style="border: none" @click="setActive(4)">
              <picture>
                <source :srcset="pdpsrc5.desktop" media="(min-width: 1024px)" />
                <source :srcset="pdpsrc5.mobile" media="(min-width: 425px)" />
                <img :alt="pdpsrc5.alt" :src="pdpsrc5.mobile" />
              </picture>
            </button>
          </slide>
          <slide v-if="pdpsrc6.desktop" class="preview">
            <button style="border: none" @click="setActive(5)">
              <picture>
                <source :srcset="pdpsrc6.desktop" media="(min-width: 1024px)" />
                <source :srcset="pdpsrc6.mobile" media="(min-width: 425px)" />
                <img :alt="pdpsrc6.alt" :src="pdpsrc6.mobile" />
              </picture>
            </button>
          </slide>
        </carousel>
      </div>
      <div class="main-picture">
        <span :class="['product-badge', badgetext ? '' : 'hide-badge']">{{ badgetext }}</span>
        <picture v-if="pdpsrc1.desktop">
          <source :srcset="pdpsrc1.desktop" media="(min-width: 1024px)" />
          <source :srcset="pdpsrc1.mobile" media="(min-width: 425px)" />
          <img :alt="pdpsrc1.alt" :src="pdpsrc1.mobile" />
        </picture>
        <picture v-if="pdpsrc2.desktop">
          <source :srcset="pdpsrc2.desktop" media="(min-width: 1024px)" />
          <source :srcset="pdpsrc2.mobile" media="(min-width: 425px)" />
          <img :alt="pdpsrc2.alt" :src="pdpsrc2.mobile" />
        </picture>
        <picture v-if="pdpsrc3.desktop">
          <source :srcset="pdpsrc3.desktop" media="(min-width: 1024px)" />
          <source :srcset="pdpsrc3.mobile" media="(min-width: 425px)" />
          <img :alt="pdpsrc3.alt" :src="pdpsrc3.mobile" />
        </picture>
        <picture v-if="pdpsrc4.desktop">
          <source :srcset="pdpsrc4.desktop" media="(min-width: 1024px)" />
          <source :srcset="pdpsrc4.mobile" media="(min-width: 425px)" />
          <img :alt="pdpsrc4.alt" :src="pdpsrc4.mobile" />
        </picture>
        <picture v-if="pdpsrc5.desktop">
          <source :srcset="pdpsrc5.desktop" media="(min-width: 1024px)" />
          <source :srcset="pdpsrc5.mobile" media="(min-width: 425px)" />
          <img :alt="pdpsrc5.alt" :src="pdpsrc5.mobile" />
        </picture>
        <picture v-if="pdpsrc6.desktop">
          <source :srcset="pdpsrc6.desktop" media="(min-width: 1024px)" />
          <source :srcset="pdpsrc6.mobile" media="(min-width: 425px)" />
          <img :alt="pdpsrc6.alt" :src="pdpsrc6.mobile" />
        </picture>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'product-images',
  props: {
    badgetext: { type: String },
    tagging: { type: Object },
    pdpsrc1: { type: Object, required: true },
    pdpsrc2: { type: Object, required: true },
    pdpsrc3: { type: Object, required: true },
    pdpsrc4: { type: Object, required: true },
    pdpsrc5: { type: Object, required: true },
    pdpsrc6: { type: Object, required: true },
  },
  data() {
    return {
      activeItem: 0,
      carouselidentifier: `carousel-${Date.now}`,
      useCarousel: !window.matchMedia('(min-width: 1024px)').matches,
      pics: {},
      previews: {},
      isPDPNavigation: 0,
      showModal: true,
    };
  },

  mounted() {
    if (window.eventBus) {
      window.eventBus.$on(`${this.carouselidentifier}-pageChange`, (activeItem) => {
        this.activeItem = activeItem;
      });
      window.eventBus.$on('mediaquery.changed', (mq) => {
        if (mq.size === 'small') {
          this.useCarousel = true;
        } else {
          this.useCarousel = false;
          this.setActive(this.activeItem);
        }
      });
    }
    if (!this.useCarousel) {
      this.isPDPNavigation = this.activeItem === 0 ? 1 : 0;
      this.setActive(this.activeItem);
    }
  },
  methods: {
    setActive(index) {
      this.$nextTick(() => {
        this.activeItem = index;
        this.pics = this.$el.querySelectorAll('.main-picture picture');
        this.previews = this.$el.querySelectorAll('.preview');
        Array.prototype.forEach.call(this.pics, (pic) => {
          pic.classList.remove('active');
        });
        Array.prototype.forEach.call(this.previews, (preview) => {
          preview.classList.remove('active');
        });
        this.pics[this.activeItem].classList.add('active');
        this.previews[this.activeItem].classList.add('active');
        if (this.isPDPNavigation === 0) this.previews[this.activeItem].focus();
      });
    },
    openVideoModal() {
      window.eventBus.$emit('openVideoModal', this.showModal);
    },
  },
};
</script>
